function toBase64Url(bytes) {
  var arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
  var binary = "";
  for (var i = 0; i < arr.length; i++) binary += String.fromCharCode(arr[i]);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function fromBase64Url(value) {
  var b64 = (value || "").toString().replace(/-/g, "+").replace(/_/g, "/");
  while (b64.length % 4) b64 += "=";
  var binary = atob(b64);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

function accountingToIso(value) {
  var raw = (value || "").toString().trim();
  if (!(raw)) return "";
  if (/^\d{14}$/.test(raw)) {
    return raw.slice(0, 4) + "-" + raw.slice(4, 6) + "-" + raw.slice(6, 8) + "T" + raw.slice(8, 10) + ":" + raw.slice(10, 12) + ":" + raw.slice(12, 14);
  }
  if (/^\d{8}$/.test(raw)) {
    return raw.slice(0, 4) + "-" + raw.slice(4, 6) + "-" + raw.slice(6, 8) + "T00:00:00";
  }
  return raw;
}

async function renderTimestampHtml(value) {
  var iso = accountingToIso(value);
  if (!(iso)) return "";
  if (!(window.UATools && typeof window.UATools.render === "function")) {
    return iso;
  }

  try {
    var rendered = await window.UATools.render({ n: "ua.ts", inner: iso });
    if (typeof rendered === "string") return rendered;
    if (rendered && typeof rendered.outerHTML === "string") return rendered.outerHTML;
    if (rendered && rendered.nodeType) {
      var holder = document.createElement("div");
      holder.appendChild(rendered.cloneNode(true));
      return holder.innerHTML;
    }
  } catch (error) {
    console.error("Unable to render timestamp.", error);
  }

  return iso;
}

function setSmallResult(node, className, message) {
  if (!(node)) return;
  while (node.firstChild) node.removeChild(node.firstChild);
  var ownerDocument = node.ownerDocument || (typeof document === "undefined" ? null : document);
  if (!(ownerDocument) || typeof ownerDocument.createElement !== "function") {
    node.textContent = (message || "").toString();
    return;
  }
  var result = ownerDocument.createElement("div");
  result.className = className || "";
  result.textContent = (message || "").toString();
  node.appendChild(result);
}

function getSelectedValues(selectEl) {
  var values = [];
  if (!(selectEl && selectEl.options)) return values;
  for (var i = 0; i < selectEl.options.length; i++) {
    if (selectEl.options[i].selected) values.push(selectEl.options[i].value);
  }
  return values;
}

module.exports = {
  toBase64Url: toBase64Url,
  fromBase64Url: fromBase64Url,
  accountingToIso: accountingToIso,
  renderTimestampHtml: renderTimestampHtml,
  setSmallResult: setSmallResult,
  getSelectedValues: getSelectedValues
};
